"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = void 0;
const isServer_1 = require("./isServer");
exports.isSafari = !isServer_1.isServer && !!navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    !!navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1;
